import { render, staticRenderFns } from "./CurvedTextZone.vue?vue&type=template&id=0393a7ee&"
import script from "./CurvedTextZone.vue?vue&type=script&lang=ts&"
export * from "./CurvedTextZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports